import { EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Descriptions,
	Form,
	Switch,
	Tooltip,
	theme,
} from "antd";
import * as COMMONS from "common/common";
import { TapAnimationComponent } from "components";
import { motion } from "framer-motion";
import EventMessageModal from "./EventMessageModal";
import { useEffect, useState } from "react";

export default function CustomReservationMessage() {
	const { colorPrimary } = theme.useToken().token;
	const form = Form.useFormInstance();
	const [isMessage, setIsMessage] = useState(false);
	const [categoryMessageDetail, setCategoryMessageDetail] = useState(false);
	const [isEventMessageModalVisible, setIsEventMessageModalVisible] =
		useState(false);
	const getIsMessage = form.getFieldValue("isMessage");

	const hideEventMessageModal = () => {
		setIsEventMessageModalVisible(false);
	};

	const showEventMessageModal = () => {
		setIsEventMessageModalVisible(true);
	};

	useEffect(() => {
		setIsMessage(getIsMessage);
		setCategoryMessageDetail(form.getFieldValue("CategoryMessageDetail"));
	}, [form, getIsMessage]);

	const onSubmitEventMessageModal = (value) => {
		form.setFieldValue("categoryMessageDetail", { ...value });
		setCategoryMessageDetail({ ...value });
	};

	return (
		<>
			<div className="flex gap-x-4 h-8 items-center">
				<div className="flex gap-x-2">
					<span>このイベントの独自予約メッセージ</span>

					<Tooltip
						title={
							<div>
								<div>OFFの場合は[設定]ページの登録内容が踏襲されます。</div>
							</div>
						}
						overlayInnerStyle={{ width: 300 }}
					>
						<QuestionCircleOutlined
							style={{
								color: colorPrimary,
								marginRight: 12,
							}}
						/>
					</Tooltip>

					<Form.Item noStyle name="isMessage">
						<Switch
							onChange={(val) => {
								form.setFieldValue("isMessage", val);
								setIsMessage(val);
							}}
						/>
					</Form.Item>

					<Form.Item
						noStyle
						name="categoryMessageDetail"
						className="hidde"
					></Form.Item>
				</div>
			</div>
			{isMessage && (
				<Col xs={24}>
					<Card
						title="通知設定"
						bordered={true}
						type="inner"
						headStyle={{
							color: "publicSettings?.PRIMARY_COLOR",
							backgroundColor: "publicSettings?.PRIMARY_LIGHT_COLOR",
						}}
						style={{
							borderColor: "publicSettings?.PRIMARY_COLOR",
						}}
					>
						<motion.div
							variants={COMMONS.ANIMATION_VARIANT_STAGGER_CONTAINER}
							initial="hidden"
							animate="show"
							exit="hidden"
						>
							<motion.div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
								<Card
									title="お客様通知"
									extra={
										<div className="flex">
											<TapAnimationComponent>
												<Button
													size="large"
													icon={<EditOutlined />}
													onClick={showEventMessageModal}
												>
													編集
												</Button>
											</TapAnimationComponent>
										</div>
									}
								>
									<Descriptions column={1} bordered layout="vertical">
										<Descriptions.Item label="予約後に配信されるメッセージ">
											<p className="whitespace-pre-wrap">
												{categoryMessageDetail?.afterReservationMessage || "ー"}
											</p>
										</Descriptions.Item>
										<Descriptions.Item label="リマインドメッセージ（予約より7日前に配信される）">
											<p className="whitespace-pre-wrap">
												{categoryMessageDetail?.reminderMessageThreeDays ||
													"ー"}
											</p>
										</Descriptions.Item>
										<Descriptions.Item label="リマインドメッセージ（予約より1日前に配信される）">
											<p className="whitespace-pre-wrap">
												{categoryMessageDetail?.reminderMessageOneDay || "ー"}
											</p>
										</Descriptions.Item>
									</Descriptions>
								</Card>
							</motion.div>
						</motion.div>
					</Card>
				</Col>
			)}

			<EventMessageModal
				// {...props}
				isEventMessageModalVisible={isEventMessageModalVisible}
				hideEventMessageModal={hideEventMessageModal}
				currentCategoryMessageDetail={categoryMessageDetail}
				onSubmit={onSubmitEventMessageModal}
			/>
		</>
	);
}
